import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { getServiceCountArray, PICKUP_LOCATION_VALUE_REQUIRES_SPECIALINSTRUCTIONS } from '../constants';
import messages from '../messages';
import style from './style.module.less';

const RequestButton = ({ pickup, requestPickup, cancelPickup }) => {
  const { totalWeightOZ, pickupLocation, company, specialInstruction } = pickup;

  const isButtonValidated = useCallback(() => {
    const isOtherLocation = pickupLocation === PICKUP_LOCATION_VALUE_REQUIRES_SPECIALINSTRUCTIONS;
    const hasValidatedLocation = !isOtherLocation || (isOtherLocation && specialInstruction);
    const hasServiceCount = getServiceCountArray(pickup).reduce((total, service) => total + service.count, 0);

    const isValidated = totalWeightOZ && pickupLocation && hasValidatedLocation && company && hasServiceCount;
    return isValidated;
  }, [company, pickupLocation, specialInstruction, totalWeightOZ, pickup]);

  const isDisabled = !isButtonValidated();

  if (pickup.isSubmitted) {
    return (
      <div className={style.button}>
        <Button onClick={cancelPickup} theme='danger'>
          <FormattedMessage {...messages.cancelButtonText} />
        </Button>
      </div>
    );
  }

  return (
    <div className={style.button}>
      <Button disabled={isDisabled} onClick={requestPickup} theme='primary'>
        <FormattedMessage {...messages.requestButtonText} />
      </Button>
    </div>
  );
};

RequestButton.propTypes = {
  pickup: PropTypes.shape({
    isSubmitted: PropTypes.number,
    totalWeightOZ: PropTypes.number,
    pickupLocation: PropTypes.string,
    company: PropTypes.string,
    specialInstruction: PropTypes.string,
  }).isRequired,
  requestPickup: PropTypes.func.isRequired,
  cancelPickup: PropTypes.func.isRequired,
};

export default RequestButton;
